import { apiGet, apiPatch } from './client';
import type { IsaFundClassification, IsaFundClassificationBatchRequest } from '../types/IsaFundClassification';

export function getIsaFundClassifications(): Promise<IsaFundClassification[]> {
  return apiGet<IsaFundClassification[]>('/api/isa-fund-classifications');
}

export function saveBatchIsaFundClassifications(added: IsaFundClassification[], modified: IsaFundClassification[], deletedIds: number[]): Promise<IsaFundClassification[]> {
  return apiPatch<IsaFundClassificationBatchRequest, IsaFundClassification[]>('/api/isa-fund-classifications/batch', { added, modified, deleted: deletedIds });
}
